import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

import { rowHeight } from './constants';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const GoalListHeader = styled.div`
  display: flex;
  align-items: center;

  width: 30rem;

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const GoalListTitle = styled.h2`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  padding: ${({ theme }) => `0 ${theme.spacing(4)}`};
  margin: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const TimelineHeader = styled.div`
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.background.default};
  overflow-x: hidden;
`;

export const TimelineHeaderContent = styled.div<{ $timelineGridWidth: number }>`
  width: ${({ $timelineGridWidth }) => `${$timelineGridWidth}px`};
`;

export const MonthsHeaderContainer = styled.div`
  display: flex;
`;

export const MonthHeader = styled.div<{
  $width: number;
  $isStartOfYear: boolean;
}>`
  ${({ theme, $isStartOfYear }) =>
    typographyToCss(
      $isStartOfYear ? theme.typography.caption : theme.typography.overline,
    )};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: ${({ $width }) => `${$width}px`};
  height: 3.2rem;
  color: ${({ theme, $isStartOfYear }) =>
    $isStartOfYear ? theme.palette.text.primary : theme.palette.grey[600]};
  border-right: 1px solid transparent;
`;

export const BodyContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

export const Body = styled.div`
  min-height: 100%;
  display: flex;
`;

export const GoalListBody = styled.div`
  width: 30rem;
  flex-shrink: 0;
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
  z-index: ${index(Options.TOPBAR)};
`;

export const CategoryList = styled.div<{ $height: number }>`
  min-height: 100%;
  height: ${({ $height }) => `${$height}px`};
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(2.5)}`};
  box-shadow: 0.2rem 0 0.4rem 0
    ${({ theme }) => rgba(theme.palette.common.black, 0.04)};
`;

export const TimelineBody = styled.div`
  flex-grow: 1;
  overflow-x: auto;
`;

export const TimelineGrid = styled.div<{
  $timelineGridWidth: number;
  $height: number;
}>`
  position: relative;
  padding: ${({ theme }) => `${theme.spacing(2.5)} 0`};

  width: ${({ $timelineGridWidth }) => `${$timelineGridWidth}px`};
  min-height: 100%;
  height: ${({ $height }) => `${$height}px`};
`;

export const MonthContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  pointer-events: none;
`;

export const MonthBg = styled.div<{ $width: number }>`
  flex-shrink: 0;
  box-sizing: border-box;
  height: 100%;
  width: ${({ $width }) => `${$width}px`};
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const GoalRow = styled.div<{ $top: number }>`
  position: absolute;
  width: 100%;
  top: ${({ $top }) => `${$top}px`};
  height: ${rowHeight}px;
`;

export const GoalRowInner = styled.div`
  position: relative;
  height: 100%;
`;
